import React, { Component } from 'react';
import { Collapse } from 'react-collapse';

import { getItemPresentation, groupItemsByStation } from '../../utils/Helpers';


class ItemRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: props.itemAmount,
      presentation: props.itemPresentation,
      grade: props.itemGrade,
      inventory: props.itemInventory
    };
  }

  componentDidUpdate(prevProps) {
    const { amount, presentation, grade, inventory } = this.state;
    const { itemAmount, itemPresentation, itemGrade, itemInventory } = this.props;
    const {
      itemAmount: oldItemAmount,
      itemPresentation: oldItemPresentation,
      itemGrade: oldItemGrade,
      itemInventory: oldItemInventory
    } = prevProps;

    if (itemAmount !== oldItemAmount || itemPresentation !== oldItemPresentation ||
        itemGrade !== oldItemGrade || itemInventory !== oldItemInventory) {
      // Update only when parent send updated info
      this.setState({
          amount: amount !== itemAmount ? itemAmount : amount,
          presentation: presentation !== itemPresentation ? itemPresentation : presentation,
          grade: grade !== itemGrade ? itemGrade : grade,
          inventory: inventory !== itemInventory ? itemInventory : inventory,
      })
    }
  }

  handleValueChange = (inputType, value) => {
    const {
      areOrderItems, index, item,
      onItemValueChange, onOrderItemValueChange,
    } = this.props;
    value = value !== "" ? value : null;
    this.setState({ [inputType]: value });
    if (areOrderItems) {
      // For order items, the index prop is the MarketOrderItem id
      onOrderItemValueChange(inputType, index, item, value);
    } else {
      onItemValueChange(inputType, index, item, value);
    }
  }

  submitRow = (event) => {
    event.preventDefault();
    const { areOrderItems, index, item, handleAddItem } = this.props;
    if (!areOrderItems) {
      handleAddItem(item, index);
    }
  }

  render() {
    const {
      areOrderItems,
      item,
      itemQtyAvg,
      handleAddItem,
      errors,
      index,
      handleDeleteItem,
      grades,
      itemPreviousOrdered
    } = this.props;

    const { amount, presentation, grade, inventory } = this.state;
    const itemPresentation = getItemPresentation(item);

    return (
      <tr>
        <td>{item.name}</td>
        {areOrderItems && (<td>{itemQtyAvg ? itemQtyAvg : '-'}</td>)}
        {areOrderItems && (
          <td>
            <div className="row m-0 border-0">
              <form className="d-flex" onSubmit={this.submitRow}>
                <div className="mr-1">
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter inventory"
                    value={inventory}
                    onChange={(event) => this.handleValueChange("inventory", event.target.value)}
                  />
                  {errors && errors.inventory && <small className="error form-control-feedback">{errors.inventory}</small>}
                  {inventory != null && inventory < 0 && (
                    <small className="error form-control-feedback">Should be empty or a non negative number</small>
                  )}
                </div>
              </form>
            </div>
          </td>
        )}
        {areOrderItems && <td>{itemPreviousOrdered ? itemPreviousOrdered : "-"}</td>}
        <td>{itemPresentation ? itemPresentation : (
          <select
            className="form-control"
            value={presentation}
            onChange={(event) => this.handleValueChange('presentation', event.target.value)}
          >
            <option value='case'>Case</option>
            <option value='piece'>Piece</option>
            {/* not allowed order by pound */}
            {item.measure_unit !== 'lb' && <option value='weight'>{item.measure_unit}</option>}
          </select>
        )}</td>
        <td>
          <div className="row m-0 border-0">
            <form className="d-flex" onSubmit={this.submitRow}>
              <div className="mr-1">
                <input
                  className="form-control"
                  type="number"
                  value={amount}
                  onChange={(event) => this.handleValueChange('amount', event.target.value)}
                />
                {errors && errors.amount && (
                <small className="error form-control-feedback">{errors.amount}</small>
                )}
                {areOrderItems && !amount && (
                  <small className="error form-control-feedback">This field is required</small>
                )}
              </div>
              {item.allows_grade_order && (
                <div>
                  <select
                    className="form-control"
                    value={grade}
                    onChange={(event) => this.handleValueChange('grade', event.target.value)}
                  >
                    <option value={-1}>Select grade</option>
                    {grades ? (
                      grades.map((grade) => {
                        return(<option value={grade.id} key={grade.id}>{grade.grade}</option>)
                      })) : <option value=" ">Loading...</option>
                    }
                  </select>
                  {areOrderItems && grade === '-1' && (
                    <small className="error form-control-feedback">This field is required</small>
                  )}
                  {item.allows_grade_order && errors && errors.non_field_errors && (
                    <small className="error form-control-feedback">This field is required</small>
                  )}
                  {item.allows_grade_order && errors && errors.grade && (
                    <small className="error form-control-feedback">This field is required</small>
                  )}
                </div>
              )}
            </form>
          </div>
        </td>
        <td>
          <span className="d-flex">
            { areOrderItems ? (
              <button
                className="ml-05 btn-sm btn-danger border-0 pointer"
                onClick={() => handleDeleteItem(index)}
              >
                <i className="fa fa-trash"></i>
              </button>
            ) : (
              <button
                className="ml-05 btn-sm btn-primary border-0 pointer"
                onClick={() => handleAddItem(item, index)}
              >
                <i className="fa fa-shopping-cart"></i>
              </button>
            )}
          </span>
        </td>
      </tr>
    )
  }
}

const StationItems = ({
  station,
  items,
  onItemValueChange,
  onOrderItemValueChange,
  handleAddItem,
  handleDeleteItem,
  grades,
}) => {
  return (
    <tbody>
      <tr className="grouped-table-section-name">
        <td colSpan="6">{`${station} (${items.length})`}</td>
      </tr>
      {items.map((item) => {
        return (
          <ItemRow
            areOrderItems
            item={item.item}
            itemQtyAvg={item.item_qty_avg}
            index={item.id}
            itemAmount={item.amount}
            itemPresentation={item.presentation}
            itemGrade={item.grade}
            itemInventory={item.inventory}
            itemPreviousOrdered={item.previous_ordered}
            errors={[]}
            onItemValueChange={onItemValueChange}
            onOrderItemValueChange={onOrderItemValueChange}
            handleAddItem={handleAddItem}
            handleDeleteItem={handleDeleteItem}
            grades={grades}
            key={item.id}
          />
        )
      })}
    </tbody>
  )
}

export default class OrderItemList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAccordionOpen: true,
    }
  }

  toggleAccordion = () => {
    this.setState((prevState) => {
      return {
        isAccordionOpen: !prevState.isAccordionOpen,
      }
    })
  }

  render() {
    const { isAccordionOpen } = this.state;
    // Common props
    const { items, areOrderItems, grades } = this.props;
    // New items props
    const {
      itemAmounts, handleListItemValueChange, handleAddItem,
      errors,
    } = this.props;
    // Order items props
    const {
      isUpdating,
      handleDeleteItem,
      handleOrderItemValueChange,
    } = this.props

    const itemsByStation = groupItemsByStation(items);
    const stationsWithItems = Object.keys(itemsByStation);

    const cardContent = (
      <div className="card-block p-0">
        <table className="table table-striped table-bordered datatable mb-0">
          <thead>
            <tr>
              <th>Item</th>
              {areOrderItems &&
                <th className="hidden-xs-down" title="Average order of the item in the last 4 weeks according to the delivery day of the week">Qty Avg</th>
              }
              {areOrderItems && <th className="hidden-xs-down">Inventory</th>}
              {areOrderItems && <th className="hidden-sm-up">Inv</th>}
              {areOrderItems && <th className="hidden-xs-down">Previous ordered</th>}
              {areOrderItems && <th className="hidden-sm-up">Prev</th>}
              <th className="hidden-xs-down">Presentation</th>
              <th className="hidden-sm-up">Pres</th>
              <th>Qty</th>
              <th className="hidden-xs-down">Actions</th>
              <th className="hidden-sm-up">Act</th>
            </tr>
          </thead>

          {areOrderItems && stationsWithItems.map((station) => {
            return (
              <StationItems
                station={station}
                items={itemsByStation[station]}
                onItemValueChange={handleListItemValueChange}
                onOrderItemValueChange={handleOrderItemValueChange}
                handleAddItem={handleAddItem}
                handleDeleteItem={handleDeleteItem}
                grades={grades}
                key={station}
              />
            )
          })}
          {!areOrderItems && (
            <tbody>
              {items.map((item, index) => {
                return (
                  <ItemRow
                    areOrderItems={areOrderItems}
                    item={item}
                    index={index}
                    itemAmount={itemAmounts[index]}
                    errors={errors[index]}
                    onItemValueChange={handleListItemValueChange}
                    onOrderItemValueChange={handleOrderItemValueChange}
                    handleAddItem={handleAddItem}
                    handleDeleteItem={handleDeleteItem}
                    grades={grades}
                    key={index}
                  />
                )
              })}
            </tbody>
          )}
        </table>
      </div>
    );

    return (
      <div className="animated fadeIn">
        <div className="card mt-2">
          {areOrderItems && (
            <div className="card-header-grey p-1 d-flex justify-content-between pointer" onClick={this.toggleAccordion}>
              <strong>My items ({items.length})</strong>
              <div className="row m-0">
                {isUpdating && <strong className="color-success">Updating...</strong>}
                <div className="shipment-package-collapse">
                  <i className={`fa ${isAccordionOpen ? "fa-caret-up" : "fa-caret-down"}`}></i>
                </div>
              </div>
            </div>
          )}
          {areOrderItems ? (
            <Collapse isOpened={isAccordionOpen}>
              {cardContent}
            </Collapse>
          ) : (
            <div>
              {cardContent}
            </div>
          )}
        </div>
      </div>
    )
  }
}
